import b from 'b_';
import cx from 'classnames';
import isNil from 'lodash/isNil';
import React from 'react';

import Text from '../../text/text';
import { TABS_THEME } from '../constants';

import './tabs__tab.scss';
import './tabs__tab_theme_rounded.scss';

interface Props {
    children?: React.ReactNode;
    counter?: number;
    disabled?: boolean;
    id: string | number;
    mix?: string;
    onTabSelect?: (id: string | number) => void;
    textId?: string;
    theme?: TABS_THEME;
    selected?: boolean;
    role?: React.AriaRole;
}

class Tab extends React.Component<Props> {
    handleTabClick = () => {
        const { id, onTabSelect, disabled } = this.props;

        if (!disabled && onTabSelect) {
            onTabSelect(id);
        }
    };

    getName = (): React.ReactNode | null => {
        const { textId, children } = this.props;

        if (children) {
            return children;
        } else if (textId) {
            return <Text id={textId} weight={Text.WEIGHT.M} />;
        }

        console.error('Не передан контент для таба');
        return null;
    };

    render() {
        const { id, counter, selected, disabled, mix, theme, role } = this.props;
        const hasCounter = !isNil(counter);

        return (
            <div
                className={cx(b('tabs', 'tab', { selected, disabled, theme }), mix)}
                key={id.toString()}
                onClick={this.handleTabClick}
                role={role}
            >
                <div className="tabs__tab-link">
                    <span>
                        {this.getName()}
                        {hasCounter && (
                            <span className="tabs__tab-counter">
                                <Text>{counter}</Text>
                            </span>
                        )}
                    </span>
                </div>
            </div>
        );
    }
}

export default Tab;
